module.exports = __webpack_public_path__ + "img/reservation-ic.19b13fa0.svg";